<template>
  <!-- Botón flotante del encargo online en móvil, ref: https://trello.com/c/TnWRRZAX
       Abajo a la izquierda: el chatbot, WhatsApp, "volver arriba" y el botón de cookies van a la derecha -->
  <NuxtLink v-if="mostrar" :to="acceso.enlace('flotante')" class="boton-flotante-encargo" :aria-label="texto">
    <v-icon size="20">mdi-file-document-edit-outline</v-icon>
    <span>{{ texto }}</span>
  </NuxtLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from '../../store/index'
import { useAccesoSolicitud, PAGINAS_ENCARGO } from '../../composables/solicitudAcceso'
import { t } from '../../composables/solicitudTextos'

const store = useStore()
const route = useRoute()
const acceso = useAccesoSolicitud()
const { isConsentGiven } = useCookieControl()

const mostrar = computed(() => {
  if (!acceso.flotante.value) return false
  if (PAGINAS_ENCARGO.test(route.path)) return false
  // Mientras se ve la barra de cookies no se muestra, para no taparla
  if ((store.NOTARIA as any)?.CookiesBaner && !isConsentGiven.value) return false
  return true
})

const texto = computed(() => acceso.textoFlotante.value || t('Encargo online'))
</script>

<style scoped>
.boton-flotante-encargo {
  position: fixed;
  left: 16px;
  bottom: 16px;
  bottom: calc(16px + env(safe-area-inset-bottom));
  z-index: 1000; /* por debajo del chatbot abierto */
  display: none;
  align-items: center;
  gap: 8px;
  max-width: calc(100vw - 120px);
  padding: 10px 18px;
  border-radius: 999px;
  background-color: rgb(var(--v-theme-primary));
  color: rgb(var(--v-theme-on-primary)) !important;
  font-weight: 600;
  font-size: 15px;
  line-height: 1.2;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}
.boton-flotante-encargo span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Solo en móvil */
@media (max-width: 959px) {
  .boton-flotante-encargo { display: inline-flex; }
}
</style>
